<script setup lang="ts">
import { type Locale, isValidLocale } from "~ui/utils/locales"
import type { Locale as I18nLocale } from "vue-i18n"
import type { DropdownMenuContentProps } from "reka-ui"
import { LocaleFlag } from "#components"

const {
  locales = [
    "da_DK",
    "en_US",
    "de_DE",
    "nb_NO",
    "sv_SE",
    "pt_PT",
    "fi_FI",
    "pl_PL",
  ],
} = defineProps<{
  locales?: Locale[]
  popoverSide?: DropdownMenuContentProps["side"]
}>()

const { locale, setLocale } = useI18n()

const emit = defineEmits<{
  openLocale: []
  selectLocale: [id: string]
}>()

const localeMap = {
  da_DK: "danish",
  en_US: "english",
  de_DE: "german",
  nb_NO: "norwegian",
  sv_SE: "swedish",
  pt_PT: "portugese",
  fi_FI: "finnish",
  pl_PL: "polish",
  nl_NL: "dutch",
}
</script>

<template>
  <DropdownMenu
    :class="$attrs.class"
    class="w-full"
    @open="$emit('openLocale')"
  >
    <DropdownTrigger class="w-full">
      <slot>
        <FormButton
          data-testid="locale_switcher"
          variant="secondary"
          :class="$attrs.class"
        >
          <span class="block pr-4 text-sm font-medium">
            {{ $t("locale.current") }}
          </span>
          <LocaleFlag v-if="isValidLocale(locale)" :locale />
        </FormButton>
      </slot>
    </DropdownTrigger>
    <DropdownContent :side="popoverSide">
      <DropdownItem
        v-for="loc in locales"
        :key="loc"
        @select="
          () => {
            setLocale(loc as I18nLocale)
            emit('selectLocale', loc)
          }
        "
      >
        <LocaleFlag :locale="loc" />
        {{ $t(`locale.${localeMap[loc]}`) }}
      </DropdownItem>
    </DropdownContent>
  </DropdownMenu>
</template>
